/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-21 15:59:48
 */
export default {
  path: 'company',
  component: () => import('@/pages/company/CompanyList'),
  meta: {
    title: '普通商户'
  },
  children: [{
      path: 'create',
      component: () => import('@/pages/company/CreateEdit'),
      meta: {
        title: '添加普通商户'
      },
    },
    {
      path: ':company_id/create',
      component: () => import('@/pages/company/CreateEdit'),
      meta: {
        title: '添加普通子商户'
      },
    },
    {
      name: 'editCompany',
      path: ':company_id/edit',
      component: () => import('@/pages/company/CreateEdit'),
      meta: {
        title: '编辑普通商户'
      },
    }
  ]
}